import _ from 'lodash';
import { determineErrorFromResponse, determineErrorIfStaticRender } from 'helpers/ContentHelper';
import { FETCH_LATEST_EPISODE_SERIES, FETCH_LATEST_EPISODE_VIDEO } from './LatestEpisodeActions';

const INITIAL_STATE = {
  errors: null,
  seriesScreenUrl: null,
  seriesDetailVideoId: null,
};

export default function(state = INITIAL_STATE, action) {
  let errors = determineErrorFromResponse(action);
  switch (action.type) {
    case FETCH_LATEST_EPISODE_VIDEO: {
      const data = _.get(action, 'payload.data');
      const latestEpisodeId = _.get(data, 'panels.member.0.items.member.0.latestEpisode.id');
      if (!latestEpisodeId) errors = determineErrorIfStaticRender();
      return {
        ...state,
        latestEpisodeId,
        errors,
      };
    }
    case FETCH_LATEST_EPISODE_SERIES: {
      const data = _.get(action, 'payload.data');
      const seriesScreenUrl = _.get(data, 'screenUrl');
      if (!seriesScreenUrl) errors = determineErrorIfStaticRender();
      return {
        ...state,
        seriesScreenUrl,
        errors,
      };
    }
    default:
      return state;
  }
}
